import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { compare } from 'fast-json-patch';
import { IntegrationIReckonInRoomCredentialsService } from '@era/locations-sdk';
import {
  InRoomCredentialsApiActions,
  InRoomCredentialsViewActions,
  InRoomCredentialsResolverActions,
} from './in-room-credentials.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class InRoomCredentialsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: IntegrationIReckonInRoomCredentialsService
  ) {}

  loadSettingsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InRoomCredentialsResolverActions.credentialsRequested),
      mergeMap(() =>
        safeMap(
          this.api.getIReckonInRoomCredentials(),
          (settings) => InRoomCredentialsApiActions.credentialsLoaded({ settings }),
          (error) => InRoomCredentialsApiActions.credentialsLoadedError({ error })
        )
      )
    );
  });

  updateSettingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InRoomCredentialsViewActions.credentialsUpdated),
      mergeMap(({ originalCredentials, credentials }) => {
        const patch = compare(originalCredentials, credentials);
        return safeMap(
          this.api.updateIReckonInRoomCredentials(credentials.id, patch),
          () => InRoomCredentialsApiActions.credentialsUpdated({ setting: credentials }),
          (error) => InRoomCredentialsApiActions.credentialsUpdatedError({ setting: originalCredentials, error })
        );
      })
    );
  });

  deleteSettingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InRoomCredentialsViewActions.credentialsDeleted),
      mergeMap(({ credential }) =>
        safeMap(
          this.api.deleteIReckonInRoomCredentials(credential.id),
          () => InRoomCredentialsApiActions.credentialsDeleted({ setting: credential }),
          (error) => InRoomCredentialsApiActions.credentialsDeletedError({ setting: credential, error })
        )
      )
    );
  });

  addSettingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InRoomCredentialsViewActions.credentialsAdded),
      mergeMap(({ credentials }) =>
        safeMap(
          this.api.addIReckonInRoomCredentials(credentials),
          (setting) => InRoomCredentialsApiActions.credentialsAdded({ setting }),
          (error) => InRoomCredentialsApiActions.credentialsAddedError({ setting: credentials, error })
        )
      )
    );
  });
}
